/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './api';
import '../common/location';
import '../bank-accounts/bank_accounts';
import '../banking/common';
import '../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "deposits": {
        "nested": {
          "bank_account_service": {
            "nested": {
              "GetBankAccountsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "includeGringottsToken": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBankAccountsResponse": {
                "fields": {
                  "unitBankAccountGroups": {
                    "type": "squareup.deposits.BankAccountGroup",
                    "id": 1,
                    "keyType": "string"
                  }
                }
              },
              "AccountHolderRelationshipToBusiness": {
                "values": {
                  "BANK_ACCOUNT_OWNERSHIP_DO_NOT_USE": 0,
                  "BUSINESS_OWNER_OR_BUSINESS": 1,
                  "CO_OWNER_OR_BUSINESS_PARTNER": 2,
                  "BENEFICIAL_OWNER_DIRECTOR_OR_SIMILAR": 3,
                  "OWNERS_SPOUSE_OR_DOMESTIC_PARTNER": 4,
                  "PARENT_ORGANIZATION": 5,
                  "POWER_OF_ATTORNEY_OR_GUARDIAN": 6,
                  "OTHER_OR_RELATIONSHIP_NOT_LISTED": 7
                }
              },
              "LinkBankAccountRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "password": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "idempotenceToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "instantPayoutSupportRequired": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "accountHolderAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 9,
                    "rule": "optional"
                  },
                  "accountHolderRelationshipToBusiness": {
                    "type": "squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness",
                    "id": 10,
                    "rule": "optional"
                  },
                  "bankAccountDetails": {
                    "type": "squareup.bank_accounts.BankAccountSpec",
                    "id": 1
                  },
                  "bankAccountToken": {
                    "type": "string",
                    "id": 2
                  },
                  "bankAccountSpec": {
                    "type": "squareup.deposits.BankAccountSpec",
                    "id": 6
                  }
                },
                "nested": {
                  "bank_account_info": {
                    "oneof": ["bankAccountDetails", "bankAccountToken", "bankAccountSpec"]
                  }
                }
              },
              "LinkBankAccountResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.deposits.bank_account_service.LinkBankAccountResponse.LinkBankAccountError",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitBankAccountGroup": {
                    "type": "squareup.deposits.BankAccountGroup",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "LinkBankAccountError": {
                    "values": {
                      "LINK_BANK_ACCOUNT_ERROR_DO_NOT_USE": 0,
                      "HAS_EXISTING_PENDING_ACCOUNT": 1,
                      "INVALID_BANK_ACCOUNT": 2,
                      "INCORRECT_PASSWORD": 3,
                      "INVALID_BANK_CODE": 4,
                      "DOES_NOT_SUPPORT_INSTANT_PAYOUT": 5,
                      "INVALID_RELATIONSHIP_OTHER": 6
                    }
                  }
                }
              },
              "ValidateBankAccountRequest": {
                "fields": {
                  "bankAccountSpec": {
                    "type": "squareup.deposits.BankAccountSpec",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ValidateBankAccountResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.deposits.bank_account_service.LinkBankAccountResponse.LinkBankAccountError",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ConfirmBankAccountRequest": {
                "fields": {
                  "confirmationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ConfirmBankAccountResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.deposits.bank_account_service.ConfirmBankAccountResponse.ConfirmBankAccountStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "confirmedBankAccount": {
                    "type": "squareup.deposits.BankAccountInfo",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bankAccountOwner": {
                    "type": "squareup.banking.Owner",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ConfirmBankAccountStatus": {
                    "values": {
                      "VERIFY_BANK_ACCOUNT_CHANGE_ERROR_DO_NOT_USE": 0,
                      "CONFIRMATION_TOKEN_INVALID": 1,
                      "SUCCESS": 2
                    }
                  }
                }
              },
              "CancelBankAccountVerificationAttemptRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bankAccountToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CancelBankAccountVerificationAttemptResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.deposits.bank_account_service.CancelBankAccountVerificationAttemptResponse.CancelBankAccountVerificationError",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CancelBankAccountVerificationError": {
                    "values": {
                      "CANCEL_BANK_ACCOUNT_VERIFICATION_ERROR_DO_NOT_USE": 0,
                      "BANK_ACCOUNT_NOT_PENDING": 1
                    }
                  }
                }
              },
              "GetDirectDebitInfoRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "countrySpecificDetail": {
                    "type": "squareup.bank_accounts.CountrySpecificDetail",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetDirectDebitInfoResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.deposits.bank_account_service.GetDirectDebitInfoResponse.GetDirectDebitInfoError",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountOwnerFirstName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountOwnerLastName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "accountOwnerEmail": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "businessAddress": {
                    "type": "squareup.deposits.bank_account_service.GetDirectDebitInfoResponse.Address",
                    "id": 5,
                    "rule": "optional"
                  },
                  "directDebitReferenceId": {
                    "type": "uint64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "bankName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "GetDirectDebitInfoError": {
                    "values": {
                      "GET_DIRECT_DEBIT_INFO_ERROR_DO_NOT_USE": 0,
                      "RATE_LIMITED": 1,
                      "NO_ACCOUNT_OWNER": 2
                    }
                  },
                  "Address": {
                    "fields": {
                      "recipient": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "address": {
                        "type": "squareup.common.location.GlobalAddress",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ResendVerificationMessageRequest": {
                "fields": {
                  "bankAccountToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ResendVerificationMessageResponse": {
                "fields": {}
              },
              "GetBanksRequest": {
                "fields": {
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBanksResponse": {
                "fields": {
                  "bankInfo": {
                    "type": "squareup.deposits.bank_account_service.GetBanksResponse.BankInfo",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BankInfo": {
                    "fields": {
                      "bankCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "primaryName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "alternativeName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetBankBranchesRequest": {
                "fields": {
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bankIdentifier": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBankBranchesResponse": {
                "fields": {
                  "branchInfo": {
                    "type": "squareup.deposits.bank_account_service.GetBankBranchesResponse.BankBranchInfo",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BankBranchInfo": {
                    "fields": {
                      "branchCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "primaryName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "alternativeName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetMerchantBankAccountsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "batchSize": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "batchToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetMerchantBankAccountsResponse": {
                "fields": {
                  "merchantBankAccounts": {
                    "type": "squareup.deposits.BankAccountInfo",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "nextBatchToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UnlinkAndDeleteMerchantBankAccountsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UnlinkAndDeleteMerchantBankAccountsResponse": {
                "fields": {
                  "unlinkedAndDeletedUnitCount": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failedUnitCount": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "statusMessage": {
                    "type": "squareup.deposits.LocalizedStatusMessage",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ExternalBankAccountService": {
                "methods": {
                  "ConfirmBankAccount": {
                    "requestType": "squareup.deposits.bank_account_service.ConfirmBankAccountRequest",
                    "responseType": "squareup.deposits.bank_account_service.ConfirmBankAccountResponse"
                  },
                  "LinkBankAccount": {
                    "requestType": "squareup.deposits.bank_account_service.LinkBankAccountRequest",
                    "responseType": "squareup.deposits.bank_account_service.LinkBankAccountResponse"
                  },
                  "CancelBankAccountVerificationAttempt": {
                    "requestType": "squareup.deposits.bank_account_service.CancelBankAccountVerificationAttemptRequest",
                    "responseType": "squareup.deposits.bank_account_service.CancelBankAccountVerificationAttemptResponse"
                  },
                  "GetBankAccounts": {
                    "requestType": "squareup.deposits.bank_account_service.GetBankAccountsRequest",
                    "responseType": "squareup.deposits.bank_account_service.GetBankAccountsResponse"
                  },
                  "GetMerchantBankAccounts": {
                    "requestType": "squareup.deposits.bank_account_service.GetMerchantBankAccountsRequest",
                    "responseType": "squareup.deposits.bank_account_service.GetMerchantBankAccountsResponse"
                  },
                  "GetBankBranches": {
                    "requestType": "squareup.deposits.bank_account_service.GetBankBranchesRequest",
                    "responseType": "squareup.deposits.bank_account_service.GetBankBranchesResponse"
                  },
                  "GetBanks": {
                    "requestType": "squareup.deposits.bank_account_service.GetBanksRequest",
                    "responseType": "squareup.deposits.bank_account_service.GetBanksResponse"
                  },
                  "GetDirectDebitInfo": {
                    "requestType": "squareup.deposits.bank_account_service.GetDirectDebitInfoRequest",
                    "responseType": "squareup.deposits.bank_account_service.GetDirectDebitInfoResponse"
                  },
                  "ResendVerificationMessage": {
                    "requestType": "squareup.deposits.bank_account_service.ResendVerificationMessageRequest",
                    "responseType": "squareup.deposits.bank_account_service.ResendVerificationMessageResponse"
                  },
                  "ValidateBankAccount": {
                    "requestType": "squareup.deposits.bank_account_service.ValidateBankAccountRequest",
                    "responseType": "squareup.deposits.bank_account_service.ValidateBankAccountResponse"
                  },
                  "UnlinkAndDeleteMerchantBankAccounts": {
                    "requestType": "squareup.deposits.bank_account_service.UnlinkAndDeleteMerchantBankAccountsRequest",
                    "responseType": "squareup.deposits.bank_account_service.UnlinkAndDeleteMerchantBankAccountsResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBankAccountsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBankAccountsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.AccountHolderRelationshipToBusiness && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.LinkBankAccountRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.LinkBankAccountResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.LinkBankAccountResponse?.nested?.LinkBankAccountError && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ValidateBankAccountRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ValidateBankAccountResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ConfirmBankAccountRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ConfirmBankAccountResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ConfirmBankAccountResponse?.nested?.ConfirmBankAccountStatus && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.CancelBankAccountVerificationAttemptRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.CancelBankAccountVerificationAttemptResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.CancelBankAccountVerificationAttemptResponse?.nested?.CancelBankAccountVerificationError && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetDirectDebitInfoRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetDirectDebitInfoResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetDirectDebitInfoResponse?.nested?.GetDirectDebitInfoError && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetDirectDebitInfoResponse?.nested?.Address && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ResendVerificationMessageRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ResendVerificationMessageResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBanksRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBanksResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBanksResponse?.nested?.BankInfo && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBankBranchesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBankBranchesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetBankBranchesResponse?.nested?.BankBranchInfo && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetMerchantBankAccountsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.GetMerchantBankAccountsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.UnlinkAndDeleteMerchantBankAccountsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.UnlinkAndDeleteMerchantBankAccountsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.bank_account_service?.nested?.ExternalBankAccountService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetBankAccountsRequest @ squareup/deposits/bank_account_service.proto at 20:1
 */
export const GetBankAccountsRequest = $root.lookupType('squareup.deposits.bank_account_service.GetBankAccountsRequest');
fixType(GetBankAccountsRequest);
Builder.createAndAttachToType(GetBankAccountsRequest);
/**
 * SOURCE GetBankAccountsResponse @ squareup/deposits/bank_account_service.proto at 34:1
 */
export const GetBankAccountsResponse = $root.lookupType('squareup.deposits.bank_account_service.GetBankAccountsResponse');
fixType(GetBankAccountsResponse);
Builder.createAndAttachToType(GetBankAccountsResponse);
/**
 * The relationship of the bank account owner to the business
 *
 * SOURCE AccountHolderRelationshipToBusiness @ squareup/deposits/bank_account_service.proto at 44:1
 */
export const AccountHolderRelationshipToBusiness = $root.lookupEnum('squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness').values;
/**
 * SOURCE LinkBankAccountRequest @ squareup/deposits/bank_account_service.proto at 67:1
 */
export const LinkBankAccountRequest = $root.lookupType('squareup.deposits.bank_account_service.LinkBankAccountRequest');
fixType(LinkBankAccountRequest, {
  idempotenceToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LinkBankAccountRequest);
/**
 * SOURCE LinkBankAccountResponse @ squareup/deposits/bank_account_service.proto at 125:1
 */
export const LinkBankAccountResponse = $root.lookupType('squareup.deposits.bank_account_service.LinkBankAccountResponse');
fixType(LinkBankAccountResponse);
Builder.createAndAttachToType(LinkBankAccountResponse);
/**
 * SOURCE LinkBankAccountError @ squareup/deposits/bank_account_service.proto at 126:3
 */
LinkBankAccountResponse.LinkBankAccountError = $root.lookupEnum('squareup.deposits.bank_account_service.LinkBankAccountResponse.LinkBankAccountError').values;
/**
 * SOURCE ValidateBankAccountRequest @ squareup/deposits/bank_account_service.proto at 155:1
 */
export const ValidateBankAccountRequest = $root.lookupType('squareup.deposits.bank_account_service.ValidateBankAccountRequest');
fixType(ValidateBankAccountRequest, {
  bankAccountSpec: {
    required: true
  }
});
Builder.createAndAttachToType(ValidateBankAccountRequest);
/**
 * SOURCE ValidateBankAccountResponse @ squareup/deposits/bank_account_service.proto at 159:1
 */
export const ValidateBankAccountResponse = $root.lookupType('squareup.deposits.bank_account_service.ValidateBankAccountResponse');
fixType(ValidateBankAccountResponse);
Builder.createAndAttachToType(ValidateBankAccountResponse);
/**
 * SOURCE ConfirmBankAccountRequest @ squareup/deposits/bank_account_service.proto at 163:1
 */
export const ConfirmBankAccountRequest = $root.lookupType('squareup.deposits.bank_account_service.ConfirmBankAccountRequest');
fixType(ConfirmBankAccountRequest);
Builder.createAndAttachToType(ConfirmBankAccountRequest);
/**
 * SOURCE ConfirmBankAccountResponse @ squareup/deposits/bank_account_service.proto at 168:1
 */
export const ConfirmBankAccountResponse = $root.lookupType('squareup.deposits.bank_account_service.ConfirmBankAccountResponse');
fixType(ConfirmBankAccountResponse);
Builder.createAndAttachToType(ConfirmBankAccountResponse);
/**
 * SOURCE ConfirmBankAccountStatus @ squareup/deposits/bank_account_service.proto at 171:3
 */
ConfirmBankAccountResponse.ConfirmBankAccountStatus = $root.lookupEnum('squareup.deposits.bank_account_service.ConfirmBankAccountResponse.ConfirmBankAccountStatus').values;
/**
 * SOURCE CancelBankAccountVerificationAttemptRequest @ squareup/deposits/bank_account_service.proto at 189:1
 */
export const CancelBankAccountVerificationAttemptRequest = $root.lookupType('squareup.deposits.bank_account_service.CancelBankAccountVerificationAttemptRequest');
fixType(CancelBankAccountVerificationAttemptRequest, {
  bankAccountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelBankAccountVerificationAttemptRequest);
/**
 * SOURCE CancelBankAccountVerificationAttemptResponse @ squareup/deposits/bank_account_service.proto at 202:1
 */
export const CancelBankAccountVerificationAttemptResponse = $root.lookupType('squareup.deposits.bank_account_service.CancelBankAccountVerificationAttemptResponse');
fixType(CancelBankAccountVerificationAttemptResponse);
Builder.createAndAttachToType(CancelBankAccountVerificationAttemptResponse);
/**
 * SOURCE CancelBankAccountVerificationError @ squareup/deposits/bank_account_service.proto at 203:3
 */
CancelBankAccountVerificationAttemptResponse.CancelBankAccountVerificationError = $root.lookupEnum('squareup.deposits.bank_account_service.CancelBankAccountVerificationAttemptResponse.CancelBankAccountVerificationError').values;
/**
 * SOURCE GetDirectDebitInfoRequest @ squareup/deposits/bank_account_service.proto at 217:1
 */
export const GetDirectDebitInfoRequest = $root.lookupType('squareup.deposits.bank_account_service.GetDirectDebitInfoRequest');
fixType(GetDirectDebitInfoRequest, {
  unitToken: {
    notEmpty: true
  },
  idempotenceKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetDirectDebitInfoRequest);
/**
 * SOURCE GetDirectDebitInfoResponse @ squareup/deposits/bank_account_service.proto at 231:1
 */
export const GetDirectDebitInfoResponse = $root.lookupType('squareup.deposits.bank_account_service.GetDirectDebitInfoResponse');
fixType(GetDirectDebitInfoResponse);
Builder.createAndAttachToType(GetDirectDebitInfoResponse);
/**
 * SOURCE GetDirectDebitInfoError @ squareup/deposits/bank_account_service.proto at 232:3
 */
GetDirectDebitInfoResponse.GetDirectDebitInfoError = $root.lookupEnum('squareup.deposits.bank_account_service.GetDirectDebitInfoResponse.GetDirectDebitInfoError').values;
/**
 * The address of the business.
 *
 * SOURCE Address @ squareup/deposits/bank_account_service.proto at 255:3
 */
GetDirectDebitInfoResponse.Address = $root.lookupType('squareup.deposits.bank_account_service.GetDirectDebitInfoResponse.Address');
fixType(GetDirectDebitInfoResponse.Address);
Builder.createAndAttachToType(GetDirectDebitInfoResponse.Address);
/**
 * SOURCE ResendVerificationMessageRequest @ squareup/deposits/bank_account_service.proto at 271:1
 */
export const ResendVerificationMessageRequest = $root.lookupType('squareup.deposits.bank_account_service.ResendVerificationMessageRequest');
fixType(ResendVerificationMessageRequest, {
  bankAccountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ResendVerificationMessageRequest);
/**
 * SOURCE ResendVerificationMessageResponse @ squareup/deposits/bank_account_service.proto at 276:1
 */
export const ResendVerificationMessageResponse = $root.lookupType('squareup.deposits.bank_account_service.ResendVerificationMessageResponse');
fixType(ResendVerificationMessageResponse);
Builder.createAndAttachToType(ResendVerificationMessageResponse);
/**
 * SOURCE GetBanksRequest @ squareup/deposits/bank_account_service.proto at 279:1
 */
export const GetBanksRequest = $root.lookupType('squareup.deposits.bank_account_service.GetBanksRequest');
fixType(GetBanksRequest, {
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(GetBanksRequest);
/**
 * SOURCE GetBanksResponse @ squareup/deposits/bank_account_service.proto at 284:1
 */
export const GetBanksResponse = $root.lookupType('squareup.deposits.bank_account_service.GetBanksResponse');
fixType(GetBanksResponse);
Builder.createAndAttachToType(GetBanksResponse);
/**
 * SOURCE BankInfo @ squareup/deposits/bank_account_service.proto at 285:3
 */
GetBanksResponse.BankInfo = $root.lookupType('squareup.deposits.bank_account_service.GetBanksResponse.BankInfo');
fixType(GetBanksResponse.BankInfo);
Builder.createAndAttachToType(GetBanksResponse.BankInfo);
/**
 * SOURCE GetBankBranchesRequest @ squareup/deposits/bank_account_service.proto at 306:1
 */
export const GetBankBranchesRequest = $root.lookupType('squareup.deposits.bank_account_service.GetBankBranchesRequest');
fixType(GetBankBranchesRequest, {
  countryCode: {
    required: true
  },
  bankIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBankBranchesRequest);
/**
 * SOURCE GetBankBranchesResponse @ squareup/deposits/bank_account_service.proto at 317:1
 */
export const GetBankBranchesResponse = $root.lookupType('squareup.deposits.bank_account_service.GetBankBranchesResponse');
fixType(GetBankBranchesResponse);
Builder.createAndAttachToType(GetBankBranchesResponse);
/**
 * SOURCE BankBranchInfo @ squareup/deposits/bank_account_service.proto at 318:3
 */
GetBankBranchesResponse.BankBranchInfo = $root.lookupType('squareup.deposits.bank_account_service.GetBankBranchesResponse.BankBranchInfo');
fixType(GetBankBranchesResponse.BankBranchInfo);
Builder.createAndAttachToType(GetBankBranchesResponse.BankBranchInfo);
/**
 * SOURCE GetMerchantBankAccountsRequest @ squareup/deposits/bank_account_service.proto at 385:1
 */
export const GetMerchantBankAccountsRequest = $root.lookupType('squareup.deposits.bank_account_service.GetMerchantBankAccountsRequest');
fixType(GetMerchantBankAccountsRequest);
Builder.createAndAttachToType(GetMerchantBankAccountsRequest);
/**
 * SOURCE GetMerchantBankAccountsResponse @ squareup/deposits/bank_account_service.proto at 401:1
 */
export const GetMerchantBankAccountsResponse = $root.lookupType('squareup.deposits.bank_account_service.GetMerchantBankAccountsResponse');
fixType(GetMerchantBankAccountsResponse);
Builder.createAndAttachToType(GetMerchantBankAccountsResponse);
/**
 * SOURCE UnlinkAndDeleteMerchantBankAccountsRequest @ squareup/deposits/bank_account_service.proto at 409:1
 */
export const UnlinkAndDeleteMerchantBankAccountsRequest = $root.lookupType('squareup.deposits.bank_account_service.UnlinkAndDeleteMerchantBankAccountsRequest');
fixType(UnlinkAndDeleteMerchantBankAccountsRequest, {
  merchantToken: {
    notEmpty: true
  },
  instrumentToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UnlinkAndDeleteMerchantBankAccountsRequest);
/**
 * SOURCE UnlinkAndDeleteMerchantBankAccountsResponse @ squareup/deposits/bank_account_service.proto at 419:1
 */
export const UnlinkAndDeleteMerchantBankAccountsResponse = $root.lookupType('squareup.deposits.bank_account_service.UnlinkAndDeleteMerchantBankAccountsResponse');
fixType(UnlinkAndDeleteMerchantBankAccountsResponse);
Builder.createAndAttachToType(UnlinkAndDeleteMerchantBankAccountsResponse);
/**
 * SOURCE ExternalBankAccountService @ squareup/deposits/bank_account_service.proto at 689:1
 */
export const ExternalBankAccountService = $root.lookupService('squareup.deposits.bank_account_service.ExternalBankAccountService');